import React, { FC, useEffect, useState } from "react";
import { Col, Row, Spin } from "antd";
import mapWeatherReportService from "@services/map-weather-report.service";
import WeatherChart from "./weather-chart";
import moment from "moment";
// import cloud from "@assets/Cloud.svg";
// import cloud_small from "@assets/Cloud_small.svg";
// import sun from "@assets/Sun.svg";
import membersService from "@services/members.service";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { find, get } from "lodash";
import "./index.scss";
import Icon from "@assets/icon_config";
// import clear_day from "@assets/icons/weather/clear-day.svg";
import { weather } from "./constants";

const Weather: FC<any> = (props) => {
  const [loadingForWeather, setWeatherLoaderFlag] = useState(false);
  const [forecastsData, setForecastsData] = useState<any>({ chartData: [] });
  const [airAndPollenData, setAirAndPollenData] = useState<any>([]);
  const [weatherType, setWeatherType] = useState<string>("");
  const [todayTempRange, setTodayTempRange] = useState<any>({});
  const [date, setDate] = useState<any>();

  useEffect(() => {
    console.log("Weather.useEffect");
    const getPostalCode = (postalCode: number, patientId: number) => {
      setWeatherLoaderFlag(true);
      mapWeatherReportService.getPostalCode(postalCode, patientId).subscribe({
        next: (v) => {
          if (v.data.length > 0) {
            let locationKey = v.data[0].Key;
            getForecastsData(locationKey);
          }
        },
        error: (e) => {
          setWeatherLoaderFlag(false);
        },
      });
    };
    const patientId = membersService?.getCurrentMember?.patient_id;
    getPostalCode(props?.data?.patientZipCode, patientId);
  }, [props?.data?.patientZipCode]);

  const getForecastsData = (locationKey: string) => {
    console.log("Weather.getForecastsData");
    mapWeatherReportService.getForecastsData(locationKey).subscribe({
      next: (v) => {
        const data = v.data.DailyForecasts;
        let finalData = [];
        let _min: any[] = [];
        let _max: any[] = [];
        if (data.length > 0) {
          finalData = data.map((item: any, idx: number) => {
            let date;
            let minTemp;
            let maxTemp;
            if (idx === 0) {
              date = `(Today) ${moment(item?.Date).format("ddd")}`;
              setDate(date);
              minTemp = item?.Temperature?.Minimum?.Value;
              setTodayTempRange({min : minTemp , max : item?.Temperature?.Maximum?.Value});
              setAirAndPollenData(item?.AirAndPollen);
              setWeatherType(item?.Day?.IconPhrase);
            } else {
              date = moment(item?.Date).format("ddd");
              minTemp = item?.Temperature?.Minimum?.Value;
            }

            maxTemp = item?.Temperature?.Maximum?.Value;
            _min.push(minTemp);
            _max.push(maxTemp);
            let values = [minTemp, maxTemp];
            return {
              date,
              "Temperature Range": values,
              "Minimum Temperature": minTemp,
              "Maximum Temperature": maxTemp,
              AirAndPollen: item?.AirAndPollen,
              IconPhrase: item?.Day?.IconPhrase,
            };
          });
        }

        let max = Math.max(..._max) + 5;
        let min = Math.min(..._min) - 5;
        setForecastsData({ chartData: finalData, min, max });
        setWeatherLoaderFlag(false);
      },
      error: (e) => {
        setWeatherLoaderFlag(false);
      },
    });
  };

  // const FtoC = (value: number) => {
  //   let celcius =  (5/9) * (value - 32)
  //   return Math.trunc(celcius);
  // };

  return (
    <Spin spinning={loadingForWeather} indicator={<HealthemSpinner />}>
      <Row className="ui-contact-details-weather">
        <WeatherChart
          data={forecastsData}
          date={date}
          onClickHandler={(val: any) => {
            const selectedItem = find(forecastsData?.chartData, { date: val });
            setDate(val);
            setTodayTempRange({ min: selectedItem["Minimum Temperature"], max: selectedItem["Maximum Temperature"] });
            setAirAndPollenData(selectedItem?.AirAndPollen);
            setWeatherType(selectedItem?.IconPhrase);
          }}
          activeTabKey={props.activeTabKey}
        />
      </Row>
      <Row className="ui-contact-details-weather__detail">
        <Col span={24} className="ui-contact-details-weather__detail__temperature">
          <span style={{ fontSize: "30px", marginTop: "10px" }}>
            <div style={{ marginTop: "10px", display: "flex", alignItems: "center" }}>
              {/* <img style={{ marginTop: "14px" }} src={cloud_small} alt="cloud_small" />
              <img style={{ marginLeft: "-15px", top: "14px" }} src={sun} alt="sun" />
              <img style={{ marginLeft: "-17px", marginBottom: "15px" }} src={cloud} alt="cloud" /> */}
              <img className="ui-contact-details-weather__detail__temperature__icon" src={`/weather/${get(weather, weatherType?.toLocaleLowerCase(), null)}`} alt="" />
              <div style={{ display: "inline-block" }}>
                <div style={{ display: "flex" }}>
                  <span
                    style={{
                      color: "#0072e3",
                      fontSize: "24px",
                      fontWeight: 600,

                      marginLeft: "12px",
                    }}
                  >
                    {todayTempRange.min ?? ''}
                  </span>
                  <div
                    style={{
                      color: "#0072e3",
                      fontSize: "16px",
                      fontWeight: 400,
                    }}
                  >
                    °F{" "}
                  </div>
                  <span
                    style={{
                      color: "#0072e3",
                      fontSize: "24px",
                      fontWeight: 600,
                    }}
                  >
                    {todayTempRange.max ? `- ${todayTempRange.max }` : ''}
                  </span>
                  <div
                    style={{
                      color: "#0072e3",
                      fontSize: "16px",
                      fontWeight: 400,
                    }}
                  >
                    °F{" "}
                  </div>
                  <span style={{ display: "flex", alignItems: "center", color: "#0072e3", fontSize: "14px", fontWeight: 500, marginLeft: "10px" }}>{weatherType}</span>
                  <span style={{ display: "flex", alignItems: "center", color: "#ef6d2a", fontSize: "12px", fontWeight: 500, marginLeft: "10px" }}>
                    {date?.includes(")")
                      ? date
                          ?.split(")")
                          ?.map((str: string, index: number) => (index === 0 ? str + ") " : str))
                          ?.join(" ")
                      : date}
                  </span>
                </div>
              </div>
            </div>
          </span>
        </Col>
        {airAndPollenData
          .filter((pollen: any) => pollen.Name === "AirQuality" || pollen.Name === "Grass" || pollen.Name === "Ragweed" || pollen.Name === "UVIndex")
          .map((item: any, index: number) => {
            let color: string = "red";
            if (item?.Name === "AirQuality") {
              color = item?.Category === "Low" ? "red" : item?.Category === "Good" ? "green" : "yellow";
            } else {
              color = item?.Category === "High" ? "red" : item?.Category === "Low" ? "green" : "yellow";
            }

            const _color: any = {
              red: "#E75547",
              yellow: "#fab342",
              green: "green",
            };
            return (
              <Col key={`weather${index}`} className="ui-contact-details-weather__detail__info">
                <span style={{ fontSize: "30px", marginTop: "10px" }}>
                  <div style={{ marginTop: "10px", display: "flex", alignItems: "center", marginBottom: "5px" }}>
                    {/* <img src={pollenIcon} alt="pollenIcon" /> */}
                    <Icon colorOfBrand={_color[color]} name={item?.Name === "AirQuality" ? "airQuality" : item?.Name === "UVIndex" ? "uv" : "pollen"} />
                    <span
                      className={`${color} ui-contact-details-weather__detail__info__title`}
                      style={{
                        fontSize: "20px",
                        fontWeight: 500,
                        marginLeft: "6px",
                      }}
                    >
                      {item?.Category}
                    </span>
                  </div>
                  <div className={color} style={{ fontSize: "12px", fontWeight: 400 }}>
                    {item?.Name === "AirQuality" ? "Air Quality Index" : item?.Name === "UVIndex" ? `UV Index` : `${item?.Name} Pollen`}
                  </div>
                </span>
              </Col>
            );
          })}
      </Row>
    </Spin>
  );
};

export default Weather;
